var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("img", {
    staticClass: "h-56 w-full lg:w-72 object-center object-cover rounded block",
    attrs: { src: _vm.fileName },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }